"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subAccountsCreateConfig = void 0;
exports.subAccountsCreateConfig = {
    canCreateSubAccounts: true,
    showCreateNewSubAccountButton: true,
};
